import ChatGPT from '@/components/ChatGPT/ChatGPT.vue'

export default {
  name: 'ChatPlayground',
  components: {
    ChatGPT
  }
}
